const WORD_SEPARATOR = /[\s,.'’\-()/]+/;

export function choiceTextStartsWithWord(text: unknown, search: unknown): boolean {
  const normalizedSearch = String(search ?? "").trim().toLocaleLowerCase();
  if (!normalizedSearch) return true;

  return String(text ?? "")
    .toLocaleLowerCase()
    .split(WORD_SEPARATOR)
    .some((word) => word.startsWith(normalizedSearch));
}

export function rankChoiceMatches<T>(
  choices: T[],
  search: unknown,
  getText: (choice: T) => unknown
): T[] {
  const normalizedSearch = String(search ?? "").trim().toLocaleLowerCase();
  if (!normalizedSearch) return [...choices];

  return choices
    .map((choice, index) => {
      const text = String(getText(choice) ?? "").toLocaleLowerCase();
      const contains = text.includes(normalizedSearch);
      const startsWithWord = choiceTextStartsWithWord(text, normalizedSearch);
      return { choice, index, contains, priority: startsWithWord ? 0 : 1 };
    })
    .filter(({ contains }) => contains)
    .sort((a, b) => a.priority - b.priority || a.index - b.index)
    .map(({ choice }) => choice);
}
